export const INCIDENT_ENDPOINTS = {
  BASE: "/v2/incident-reports",

  CREATE: "/v2/incident-reports",
  GET_ALL: "/v2/incident-reports",
  GET_STATUS_COUNTS: "/v2/incident-reports/status-counts",
  GET_BY_ID: "/v2/incident-reports/:id",
  UPDATE: "/v2/incident-reports/:id",
  DELETE: "/v2/incident-reports/:id",

  STATUS_UPDATE: "/v2/incident-reports/:id/status",

  SIGNED_URLS: "/v2/incident-reports/signed-urls",
  UPLOAD_REQUEST: "/v2/incident-reports/:id/upload-request",
  CONFIRM_UPLOAD: "/v2/incident-reports/:id/confirm-upload",

  PDF: "/v2/incident-reports/:id/pdf",
  SEND_NOTIFICATION: "/v2/incident-reports/:id/send-notification",
};

export const INVITATION_ENDPOINTS = {
  BASE: "/v2/incident-reports/invitations",

  CREATE: "/v2/incident-reports/invitations",
  GET_ALL: "/v2/incident-reports/invitations",
  GET_BY_ID: "/v2/incident-reports/invitations/:id",
  RESEND: "/v2/incident-reports/invitations/:id/resend",
  DELETE: "/v2/incident-reports/invitations/:id",
};

export const PUBLIC_ENDPOINTS = {
  VALIDATE: "/v2/incident-reports/public/invite/validate",
  SUBMIT: "/v2/incident-reports/public/submit",
  UPLOAD_REQUEST: "/v2/incident-reports/public/upload/request",
  PREVIEW_REQUEST: "/v2/incident-reports/public/preview/request",
  PREVIEW: "/v2/incident-reports/public/preview",
  PDF_DOWNLOAD: "/v2/incident-reports/public/pdf"
};
